/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userssearch.rpc.AppUsersSearch
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type PortalUser = {
  email: string;
  firstName: string;
  lastName: string;
  userId: number;
  hubId: number;
  confirmed: boolean;
  visible: boolean;
  hubspotter: boolean;
};

export type UsersSearchError = {
  errorType: UsersSearchErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UsersSearchErrorType =
  | 'UNKNOWN'
  | 'PAGE_LENGTH_EXCEEDS_MAXIMUM'
  | 'CRM_SEARCH_VALIDATION'
  | 'CRM_SEARCH_AUTHORIZATION'
  | 'CRM_SEARCH_RATE_LIMITED'
  | unhandledEnumCase;

export type AppUsersSearchRequest = {
  searchQuery?: string;
  mustMatchUserIds: Default<number[]>;
  mustNotMatchUserIds: Default<number[]>;
  offset: Default<number>;
  onlyConfirmedUsers: Default<boolean>;
  onlyVisibleUsers: Default<boolean>;
  onlyHubspotters: Default<boolean>;
  uniqueUserIds: Default<boolean>;
  includePartnerUsers: Default<boolean>;
  includeDeactivatedUsers: Default<boolean>;
  includeVirtualMamUsers: Default<boolean>;
  includeAppServiceAccountUsers: Default<boolean>;
  includeWorkAgentUsers: Default<boolean>;
  includeHiddenUsers: Default<boolean>;
  pageLength: Default<number>;
};

export type UsersSearchResponse = {
  total: number;
  results: Default<PortalUser[]>;
  hasMore: boolean;
  offset: number;
};

export type SearchRequestType = Requestify<AppUsersSearchRequest>;
export type SearchResponseType = UsersSearchResponse;
export type SearchErrorType = UsersSearchError & HubspotMetadata;
export const searchRpc: ChirpAvroRpcDetails<
  SearchRequestType,
  SearchResponseType,
  SearchErrorType,
  false
> = {
  serviceName: 'com.hubspot.userssearch.rpc.AppUsersSearch',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'USJn6TILxEIjXgNYzFPICR769JFskdG8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
